import { deleteData, postData, postMediaData } from 'helpers/apiHelper'
import { MAIN_PATH, UPLOAD_IMAGE_PATH, DELETE_FILE, GET_PRESIGNED_URL } from './apiPath'
import { deleteUploadImage, } from 'store/actions/file';
import Axios from "axios";
import { ERROR_MESSAGE } from "common/constantMessage";

//upload image
export function uploadImage_(value, callback) {
  return postMediaData(`${MAIN_PATH}${UPLOAD_IMAGE_PATH}`, value)
}

//delete image
export function deleteFile(payload) {
  return deleteData(`${MAIN_PATH}${DELETE_FILE}`, payload);
}


// upload image s3 pre-signed url
export async function uploadFilePresignedUrl(payload, callback) {
  try {
    const { file, values } = payload;

    values.acl = values.acl === "private" ? "private" : "public-read";
    
    let response = await postData(`${MAIN_PATH}${GET_PRESIGNED_URL}`, values);
    const {url, fileKey, public_url} = response?.body;
    if(!url) {
      throw new Error("Failed to generate presign url");
    }

    const fileUrl = url.split("?")[0];

    await Axios.put(url, file, {
      headers: {
        'Content-Type': file.type
      }
    });

    return {fileUrl, fileKey, public_url}
  } catch(error) {
    ERROR_MESSAGE("Failed to upload file");
    throw error;
  }
}